<template>
  <hm-content title="技师列表" class="staff-container">
    <div slot="header">
      <hm-step :steps="steps" :step="4"></hm-step>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddStaff"
          >新增技师</el-button
        >
      </div>
      <div>
        <el-select
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          class="mr10"
          filterable
          clearable
        >
          <el-option
            v-for="item in storeList.list"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="serverId"
          placeholder="选择服务"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in serviceList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="keyWord"
          placeholder="输入技师姓名"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          placeholder="输入名称"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="staffList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          width="50"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workNum"
          label="工号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          label="手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverName"
          label="分配服务"
        >
          <!-- <template slot="header">
            分配服务
            <el-tooltip class="item" effect="dark" content="点击服务即可设置排班" placement="top-start">
              <el-button type="text" size="mini">？</el-button>
            </el-tooltip>
          </template>-->
          <template slot-scope="scope">
            <el-button
              v-for="(v, i) in scope.row.serviceList"
              :key="i"
              size="mini"
              type="text"
              @click="showSchedulingModal(scope.row, v.id)"
            >
              {{ v.name }}
              <span v-show="v.typeFormat">({{ v.typeFormat }})</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeOutlet"
          label="归属门店"
        ></el-table-column>
        <!-- <el-table-column header-align="center" align="center" prop="position" label="角色"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="备注"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="staffList.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="新增技师"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择门店：" prop="storeOutletId">
          <el-select
            v-model="ruleForm.storeOutletId"
            placeholder="选择门店"
            @change="queryServiceList"
            size="small"
            filterable
          >
            <el-option
              v-for="item in storeList.list"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="工号：" prop="workNum">
          <el-input
            size="small"
            type="num"
            clearable
            v-model.trim="ruleForm.workNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobilePhone">
          <el-input
            size="small"
            @mousewheel.prevent.native
            type="number"
            clearable
            v-model.trim="ruleForm.mobilePhone"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间：" prop="workTime">
          <el-time-picker
            is-range
            size="small"
            value-format="HH:mm"
            format="HH:mm"
            v-model="ruleForm.workTime"
            range-separator="至"
            start-placeholder="上班时间"
            end-placeholder="下班时间"
            placeholder="选择时间范围"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="技师头像：">
          <my-upload
            field="file"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            noCircle
            :width="100"
            :height="100"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'mallDecoration' }"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <div class="headPortrait-wrapper">
            <img @click="toggleShow" :src="ruleForm.headPortrait" alt="头像" />
          </div>
        </el-form-item>
        <el-form-item label="分配服务：">
          <el-select
            clearable
            multiple
            :disabled="!ruleForm.storeOutletId"
            v-model="ruleForm.serverIdList"
            placeholder="选择服务(可多选)"
            size="small"
            filterable
            class="mr10 multiple-select"
          >
            <el-option
              v-for="item in serviceList.list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            size="small"
            type="textarea"
            clearable
            v-model.trim="ruleForm.description"
          ></el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="'设置' + dialogTitle + '排班'"
      :visible="modalVisible"
      @close="closeModal"
      :close-on-click-modal="false"
      width="680px"
    >
      <hm-time-select ref="timeSelect" :yAxis="yAxis"></hm-time-select>
      <div class="flex item-center mb20">
        <span>是否可被预约：</span>
        <el-switch
          style="display: block"
          v-model="status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="开启"
          inactive-text="关闭"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
        <span class="form-tip"
          >（关闭后，小程序{{ dialogTitle }}将不会显示）</span
        >
      </div>
      <div class="flex flex-center" style="margin-top: 20px">
        <el-button type="primary" size="small" @click="saveScheduling"
          >保存</el-button
        >
        <el-button size="small" @click="closeModal">返回</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import HmTimeSelect from "@/components/HmTimeSelect";
import { getLoginUser } from "@/utils/auth";
import { mapGetters } from "vuex";
import HmStep from "@/components/HmStep";
import moment from "moment";
export default {
  components: { HmTimeSelect, myUpload, HmStep },
  data() {
    return {
      steps: [
        {
          link: "StoreList",
          name: "门店列表"
        },
        {
          link: "ServiceCategory",
          name: "服务分类列表"
        },
        {
          link: "ServiceList",
          name: "项目列表"
        },
        {
          link: "StaffList",
          name: "技师列表"
        }
      ],
      status: 1,
      yAxis: [],
      dialogTitle: "",
      show: false,
      pageSize: 10,
      currentRow: {},
      storeId: "",
      keyWord: "",
      currentServiceId: "",
      serviceId: "",
      serverId: "",
      service: "",
      activeTab: 0,
      currentPage: 1,
      dateAndTime: [],
      modalVisible: false,
      dialogFormVisible: false,
      storeOutletId: "",
      defaultHeadPortrait:
        "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png",
      ruleForm: {
        workTime: [new Date("2019-07-30 07:00"), new Date("2019-07-30 21:00")],
        workEndTime: "",
        workStartTime: "",
        serverIdList: [],
        storeOutletId: "",
        workNum: "",
        description: "",
        name: "",
        mobilePhone: "",
        headPortrait:
          "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png"
      },
      rules: {
        workTime: {
          required: true,
          message: "请选择上下班时间",
          trigger: "change"
        },
        storeOutletId: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        mobilePhone: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入技师姓名", trigger: "blur" },
          { max: 10, message: "长度应小于10个字", trigger: "blur" }
        ],
        workNum: [
          { required: true, message: "请输入工号", trigger: "blur" },
          { max: 10, message: "长度应小于10个字", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    const { storeId, storeName } = getLoginUser();
    this.storeId = storeId;
    this.ruleForm.storeName = storeName;
    this.queryList();
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
    this.ruleForm.headPortrait = this.defaultHeadPortrait;
  },
  computed: mapGetters([
    "staffList",
    "storeList",
    "serviceList",
    "guiderWorkTimeList",
    "disabledSchedulingList"
  ]),
  watch: {
    guiderWorkTimeList(val) {
      if (val) {
        this.yAxis = val;
      }
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      this.ruleForm.headPortrait = jsonData.result;
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail() {},
    showSchedulingModal(row, serverId) {
      this.currentRow = row;
      this.currentServiceId = serverId;
      this.modalVisible = true;
      this.status = 1;
      const index = row.serverId.split(",").findIndex(v => serverId === v);
      const serverName = row.serverName.split(",")[index];
      this.dialogTitle = `${row.name}-${serverName}`;
      if (this.$refs.timeSelect) {
        this.$refs.timeSelect.cleaarSelected();
      }
      this.$store
        .dispatch("queryGuiderWorkTime", {
          serverId,
          storeUserId: this.currentRow.id
        })
        .then(workTime => {
          if (workTime.result.length) {
            this.$nextTick(() => {
              const dateList = this.$refs.timeSelect.getAllIndex();
              this.$store
                .dispatch("queryDisabledScheduling", {
                  serverId: this.currentServiceId,
                  storeUserId: this.currentRow.id,
                  storeOutletId: this.currentRow.storeOutletId,
                  dateList
                })
                .then(res => {
                  if (res.code === "0" && res.result) {
                    const indexs = res.result || [];
                    if (indexs.length) {
                      this.$refs.timeSelect.eleList.forEach(item => {
                        indexs.forEach(v => {
                          if (item.index === +v) {
                            item.disabled = true;
                          }
                        });
                      });
                    }
                  }
                  this.$store
                    .dispatch("querySchedulingList", {
                      serverId,
                      storeUserId: row.id,
                      storeOutletId: row.storeOutletId
                    })
                    .then(selectRes => {
                      if (selectRes.code === "0" && selectRes.result) {
                        this.status = selectRes.result.dateRule.status;
                        const indexs = selectRes.result.indexs || [];
                        if (indexs.length) {
                          this.$refs.timeSelect.eleList.forEach(item => {
                            indexs.forEach(v => {
                              if (item.index === +v) {
                                item.selected = true;
                              }
                            });
                          });
                        }
                      }
                    });
                });
            });
          }
        });
      // 先查询排班
    },
    closeModal() {
      this.modalVisible = false;
      if (this.$refs.timeSelect) {
        this.$refs.timeSelect.eleList.forEach(item => {
          item.selected = false;
        });
      }
    },
    saveScheduling() {
      const dateList = this.$refs.timeSelect.getSelectedEleList();
      this.$store
        .dispatch("editSchedulingList", {
          serverId: this.currentServiceId,
          storeUserId: this.currentRow.id,
          storeOutletId: this.currentRow.storeOutletId,
          dateList,
          status: this.status
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.modalVisible = false;
            this.$refs.timeSelect.cleaarSelected();
          }
        });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryStaffList", {
        keyWord: this.keyWord,
        serverId: this.serverId,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeOutletId: this.storeOutletId
      });
    },
    queryServiceList(e) {
      this.$store.dispatch("queryServiceList", {
        pageSize: 999,
        storeOutletId: e
      });
      this.ruleForm.serverIdList = [];
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toAddStaff() {
      this.mode = "add";
      this.dialogFormVisible = true;
      this.ruleForm.workTime = [
        new Date("2019-07-30 07:00"),
        new Date("2019-07-30 21:00")
      ];
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let actionName;
          let params = this.ruleForm;
          if (this.ruleForm.workTime.length) {
            if (
              this.ruleForm.workTime[0].length <= 5 &&
              this.ruleForm.workTime[1].length <= 5
            ) {
              this.ruleForm.workStartTime = this.ruleForm.workTime[0];
              this.ruleForm.workEndTime = this.ruleForm.workTime[1];
            } else {
              this.ruleForm.workStartTime = moment(
                this.ruleForm.workTime[0]
              ).format("HH:mm");
              this.ruleForm.workEndTime = moment(
                this.ruleForm.workTime[1]
              ).format("HH:mm");
            }
          }

          params = Object.assign(params, {
            serverId: this.ruleForm.serverIdList.join(",")
          });
          if (this.mode === "add") {
            actionName = "addStaff";
          } else if (this.mode === "edit") {
            actionName = "editStaff";
            params = Object.assign(params, { id: this.currentRowId });
          }
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.resetForm(formName);
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      this.ruleForm.serverIdList = [];
      this.dialogFormVisible = false;
      this.ruleForm.headPortrait = this.defaultHeadPortrait;
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.currentRowId = row.id;
      this.mode = "edit";
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
      this.ruleForm.workTime = [
        new Date(
          moment().format(
            "YYYY-MM-DD " + (this.ruleForm.workStartTime || "08:00")
          )
        ),
        new Date(
          moment().format(
            "YYYY-MM-DD " + (this.ruleForm.workEndTime || "22:00")
          )
        )
      ];
      this.$store.dispatch("queryStoreList", { pageSize: 999 });
      this.queryServiceList(row.storeOutletId);
      this.ruleForm.serverIdList = row.serverId
        ? row.serverId.split(",").map(v => Number(v))
        : [];
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("deleteStaff", { id }).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "删除技师成功！",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    }
    // // 移除上传文件
    // handleRemove() {
    //   this.ruleForm.headPortrait = "";
    // },
    // deleteListHeader() {
    //   this.$refs.uploadAvatar.handleRemove();
    // },
    // // 上传成功后的回调
    // uploadSuccess(response) {
    //   this.ruleForm.headPortrait = response.result;
    //   this.$message({
    //     type: "success",
    //     message: "上传成功！"
    //   });
    // },
    // // 上传错误
    // uploadError() {
    //   this.$message({
    //     message: "上传失败，请重试!",
    //     type: "warning"
    //   });
    // },
    // // 上传前对文件的大小的判断
    // beforeUpload(file) {
    //   const extension =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
    //   const extension2 =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpeg";
    //   const extension3 =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
    //   const extension4 =
    //     file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
    //   // file.size单位为b，除以1024得到kb
    //   const limitSize = file.size / 1024 <= 100;
    //   if (!extension && !extension2 && !extension3 && !extension4) {
    //     this.$message({
    //       message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
    //       type: "warning"
    //     });
    //   }
    //   if (!limitSize) {
    //     this.$message({
    //       message: "上传模板大小不能超过 100k!",
    //       type: "warning"
    //     });
    //   }
    //   return (extension || extension2 || extension3 || extension4) && limitSize;
    // }
  }
};
</script>

<style scoped lang="scss">
.staff-container {
  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
}

.tip {
  color: #999;
  margin: 10px 0;
  font-size: 14px;
}
.headPortrait-wrapper {
  width: 100px;
  height: 100px;
  border: 1px solid#dcdfe6;
  cursor: pointer;
  img {
    width: 100px;
  }
}
</style>
